import { Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map } from 'rxjs/operators';

import {
  entityCurrentEmpresaLoadRequest,
  entityCurrentEmpresaLoadSuccess
} from './entity-current-empresa.actions';
import { entityPersonasJuridicaAddSuccess } from '../entity-personas-juridica/entity-personas-juridica.actions';
import { entityPersonasFisicaAddSuccess } from '../entity-personas-fisica/entity-personas-fisica.actions';

@Injectable()
export class CurrentEmpresaEffects {
  // load
  loadRequestCurrentEmpresa = createEffect(() => {
    return this.actions$.pipe(
      ofType(entityCurrentEmpresaLoadRequest),
      map((action) => entityCurrentEmpresaLoadSuccess({ item: action.item }))
    );
  });

  loadRequestCurrentEmpresaRegistroPJ = createEffect(() => {
    return this.actions$.pipe(
      ofType(entityPersonasJuridicaAddSuccess),
      map((action) => entityCurrentEmpresaLoadSuccess(
        {
          item: {
            id: action.item.entidad_productiva.id,
            nombre: action.item.persona_juridica.denominacion_social
          }
        }
      ))
    )
  });

  loadRequestCurrentEmpresaRegistroPF = createEffect(() => {
    return this.actions$.pipe(
      ofType(entityPersonasFisicaAddSuccess),
      map((action) => entityCurrentEmpresaLoadSuccess(
        {
          item: {
            id: action.item.entidad_productiva.id,
            nombre: action.item.nombre_completo || 'Empresa Fisica'
          }
        }
      ))
    )
  });
  constructor(private actions$: Actions) {}
}
